import { render } from "./Column.vue?vue&type=template&id=2a69ef46&scoped=true"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2a69ef46"

export default script